import { useSearchParams } from 'react-router-dom-latest';
import { BrokerUrlParams } from 'broker/broker-routes';
import { TOOLBOX_TABS, ToolboxTabs } from 'broker/pages/SubmissionWorkspacePage/types';

export function useGetActiveTab() {
  const [searchParams] = useSearchParams();
  const activeTabParam = searchParams.get(BrokerUrlParams.ACTIVE_TAB) as ToolboxTabs;
  return Object.values(TOOLBOX_TABS).includes(activeTabParam) ? activeTabParam : undefined;
}
